/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';

import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import withStyles from '@material-ui/core/styles/withStyles';
import { withRouter } from 'react-router';
import {
    object,
    shape,
    string,
} from 'prop-types';
import AccountMenuPlants from './AccountMenuPlants';

const baseURL = '/account';
// TODO: My Account's menu need to be store in content stack
const listItem = [
    /* {
        id: 1,
        label: 'Account Overview',
        url: `${baseURL}`,
    }, */
    {
        id: 1,
        label: 'MY PROFILE',
        url: `${baseURL}/profile`,
    },
    {
        id: 2,
        label: 'MY ORDERS',
        url: `${baseURL}/orders`,
    },
    {
        id: 3,
        label: 'RESET PASSWORD',
        url: `${baseURL}/reset-password`,
    },
    {
        id: 4,
        label: 'WISHLIST',
        url: `${baseURL}/wishlist`,
    },
    /* {
        id: 4,
        label: 'Address Book',
        url: `${baseURL}/address-book`,
    }, */
    /* {
        id: 5,
        label: 'Manage Subscriptions',
        url: `${baseURL}/subscriptions`,
        flag: 'is-account-subscription-enabled',
    }, */
    /* {
        id: 6,
        label: 'Payment & Billing',
        url: `${baseURL}/billing-address`,
    }, */
    /* {
        id: 8,
        label: 'Email Preference',
        url: `${baseURL}/email-preference`,
    }, */
    /* {
        id: 9,
        label: 'Passport',
        url: `${baseURL}/passport`,
        userRole: 'P',
    }, */
];

const styles = ({
    leftMenus: {
        textDecoration: 'none',
        listStyle: 'none',
        lineHeight: 1.5,
        paddingRight: 12, // rowSpacing
        minWidth: 160,
        '& > span': {
            marginBottom: '12px', // rowSpacing
            display: 'block',
            '& .label': {
                fontSize: '14px !important',
            },
        },
    },
    listItem: {
        display: 'inline-block',
        color: '#6c95e2', // TODO
        textDecoration: 'underline',
        lineHeight: '24px', // rowSpacing * 2
        cursor: 'pointer',
        paddingLeft: 24, // rowSpacing * 2
    },
    trackOrder: {
        marginTop: 'inherit',
    },
    arrowIcon: {
        verticalAlign: 'middle',
        fontSize: '16px',
        position: 'absolute',
        top: 2,
        left: 5,
    },
});

class AccountLeftMenu extends Component {
    handleListItemClicked = (url) => {
        const { history: { push } } = this.props;
        push(url);
    };

    render() {
        const {
            classes, userProfile, featureFlags, customClass, brand,
        } = this.props;

        const currentUrl = typeof window !== 'undefined' ? window.location.pathname : '/';

        if (brand?.code === 'PLA') {
            /* eslint-disable react/jsx-props-no-spreading */
            return <AccountMenuPlants {...this.props} />;
        }

        return (
            <>
                <Grid className={`${classes.leftMenus} ${classes[customClass]}`} item xs={2}>
                    {listItem.map((list) => {
                        if (
                            (list.userRole
                        && list.userRole !== userProfile.userRole)
                    || (list.flag
                        && featureFlags[list.flag]
                        && featureFlags[list.flag] === 'N')
                        ) {
                            return '';
                        }
                        return (
                            ((currentUrl === list.url) || (list.regEx?.test(currentUrl)))
                                ? (
                                    <span key={list.label} className="position-relative padding-left-2x">
                                        <PlayArrowIcon className={`${classes.arrowIcon}`} />
                                        <span className="label"> {list.label}</span>
                                    </span>
                                )
                                :                                        (
                                    <div key={list.label} className="display-block margin-bottom">
                                        <span
                                            role="presentation"
                                            onClick={() => this.handleListItemClicked(list.url)}
                                            key={list.id}
                                            className={classes.listItem}
                                        > {list.label}
                                        </span>
                                    </div>
                                )
                        );
                    })}
                </Grid>
            </>
        );
    }
}

AccountLeftMenu.defaultProps = {
    history: {},
    customClass: '',
};

AccountLeftMenu.propTypes = {
    classes: object.isRequired,
    userProfile: shape({
        userRole: string,
    }).isRequired,
    history: object,
    customClass: string,
    featureFlags: object.isRequired,
    brand: object.isRequired,
};

export default withRouter(withStyles(styles)(AccountLeftMenu));
